<template>
  <!-- 後台共用分頁（設計稿 Pagination）：共 N 筆 ＋ 圓形頁碼(含省略號) ＋ 每頁下拉 -->
  <div class="ur-pg">
    <span class="ur-pg-total">{{ $t('URBANRENEWAL_ADMIN.PG.TOTAL', { count: total }) }}</span>

    <div class="ur-pg-buttons">
      <button
        class="ur-pg-btn"
        :disabled="page <= 1"
        @click="go(page - 1)"
      >&#8249;</button>

      <template v-for="(p, i) in pageList">
        <button
          v-if="p !== '...'"
          :key="'p' + i"
          class="ur-pg-btn"
          :class="{ 'is-active': p === page }"
          @click="go(p)"
        >{{ p }}</button>
        <span v-else :key="'e' + i" class="ur-pg-btn ur-pg-ellipsis">&#8230;</span>
      </template>

      <button
        class="ur-pg-btn"
        :disabled="page >= totalPages"
        @click="go(page + 1)"
      >&#8250;</button>
    </div>

    <div class="ur-pg-rows" ref="rowsWrap">
      <div class="ur-pg-rows-trigger" @click="showRows = !showRows">
        {{ $t('URBANRENEWAL_ADMIN.PG.RPP', { n: rpp }) }}
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
      <div v-if="showRows" class="ur-pg-rows-menu">
        <div
          v-for="opt in rppOptions"
          :key="opt"
          class="ur-pg-rows-opt"
          :class="{ sel: opt === rpp }"
          @click="setRpp(opt)"
        >{{ opt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UrbanRenewalPagination',

  props: {
    total: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
    rpp: { type: Number, default: 20 },
    rppOptions: { type: Array, default: () => [20, 50, 100, 200] },
  },

  data() {
    return { showRows: false };
  },

  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.rpp));
    },
    // 頁碼清單（含省略號）：1 … c-1 c c+1 … last
    pageList() {
      const tp = this.totalPages;
      if (tp <= 7) {
        return Array.from({ length: tp }, (_, i) => i + 1);
      }
      const cur = this.page;
      const list = [1];
      if (cur > 4) list.push('...');
      const start = Math.max(2, cur - 1);
      const end = Math.min(tp - 1, cur + 1);
      for (let i = start; i <= end; i++) list.push(i);
      if (cur < tp - 3) list.push('...');
      list.push(tp);
      return list;
    },
  },

  mounted() {
    document.addEventListener('mousedown', this.onDocClick);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onDocClick);
  },

  methods: {
    go(p) {
      if (p < 1 || p > this.totalPages || p === this.page) return;
      this.$emit('update:page', p);
    },
    setRpp(opt) {
      this.showRows = false;
      if (opt === this.rpp) return;
      this.$emit('update:rpp', opt);
      this.$emit('update:page', 1);   // 換每頁數回到第 1 頁
    },
    onDocClick(e) {
      if (this.showRows && this.$refs.rowsWrap && !this.$refs.rowsWrap.contains(e.target)) {
        this.showRows = false;
      }
    },
  },
};
</script>
